import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-listagem-frente-trabalho',
  templateUrl: './listagem-frente-trabalho.component.html',
  styleUrls: ['./listagem-frente-trabalho.component.scss'],
})
export class ListagemFrenteTrabalhoComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
